export default "__VITE_ASSET__Cpy62OJI__"